module.exports = __webpack_public_path__ + "img/20190611_113036_011.857410c2.jpg";